import { create } from 'zustand';

export enum SnackbarType {
    SUCCESS = 'success',
    ERROR = 'error',
    WARNING = 'warning',
    INFO = 'info',
  }

  
interface SnackbarState {
  isOpen: boolean;
  message: string;
  type: SnackbarType;
  showSnackbar: (message: string, type: SnackbarType) => void;
  closeSnackbar: () => void;
}

export const useSnackbarStore = create<SnackbarState>((set) => ({
  isOpen: false,
  message: '',
  type: SnackbarType.INFO, // ברירת מחדל
  showSnackbar: (message: string, type: SnackbarType) =>
    set({ isOpen: true, message, type }),
  closeSnackbar: () => set({ isOpen: false, message: '', type: SnackbarType.INFO }),
}));
